import React from "react";

export const Footer = (props) => {
  return (
    <section className="footer">
      <p>
        Lorem Ipsum is simply dummy text of the printing and typesetting
        industry.
      </p>
    </section>
  );
};
